import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiInfoBanner, NoddiLink } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';

type Props = {
  /** Override default time-picker path (e.g. proposal flow). */
  timeWindowPath?: string;
};

/** Warning + CTA when the held stationary slot has expired and must be re-picked. */
export const StationaryReservationExpiredBanner = ({
  timeWindowPath = customerRoutes.newStationaryBookingTimeWindow.getPath()
}: Props) => (
  <NoddiInfoBanner
    variant='warning'
    title={t`Time slot expired`}
    texts={[{ value: t`Your reserved time slot expired. Please select a time again.` }]}
    actionNode={
      <NoddiLink to={timeWindowPath} size='small' variant='outline'>
        <Trans>Choose a new time</Trans>
      </NoddiLink>
    }
  />
);
